<script setup>
import Timepicker from "@Components/Form/Timepicker.vue";
import { planningDays, planningPeriods } from "@Utils/project";
import Step from "@Components/Stepper/Step.vue";
import { useI18n } from "vue-i18n";
import { FormCheckboxGroup, FormCheckboxGroupOption, FormInput, FormLabel, FormListbox, FormSwitch } from "@Components/Form";
import Datepicker from "@Components/Form/Datepicker.vue";

const props = defineProps(["modelValue", "step"]);
const emit = defineEmits(["update:modelValue", "next", "back", "skip"]);

const { t: __ } = useI18n();
</script>

<template>
    <Step class="px-4 lg:px-8 sm:px-6" :step="step" :processing="modelValue.processing" @next="$emit('next')" @back="$emit('back')" @skip="$emit('skip')">
        <template #header>
            <div class="mx-auto max-w-3xl">
                <h3 class="text-4xl font-semibold leading-tight text-center text-gray-900 dark:text-white">
                    {{ __("Planifiez vos publications") }}
                </h3>
            </div>
        </template>

        <div class="mx-auto max-w-4xl flex flex-col space-y-12">
            <div class="space-y-12">
                <FormSwitch
                    :modelValue="!modelValue.planning.enabled"
                    @update:modelValue="($event) => (modelValue.planning.enabled = !$event)"
                    :label="__('Publier toutes les publications maintenant')" />

                <template v-if="modelValue.planning.enabled">
                    <div class="flex flex-wrap items-center gap-3">
                        <div class="flex items-center gap-3">
                            <FormLabel>{{ __("Publier") }}</FormLabel>
                            <div class="max-w-[7rem]">
                                <FormInput type="number" min="1" v-model="modelValue.planning.per_period" />
                            </div>
                        </div>
                        <div class="flex items-center gap-3">
                            <FormLabel>{{ __("publications par") }}</FormLabel>
                            <FormListbox v-model="modelValue.planning.period" :items="planningPeriods" required></FormListbox>
                        </div>
                        <div class="flex items-center gap-3">
                            <FormLabel>{{ __("à partir du") }}</FormLabel>
                            <div class="max-w-sm">
                                <Datepicker v-model="modelValue.planning.start_date" />
                            </div>
                        </div>
                    </div>

                    <FormCheckboxGroup v-model="modelValue.planning.days" :label="__('Jours de publication')">
                        <div class="grid grid-cols-1 gap-y-6 mt-4 sm:grid-cols-8 sm:gap-x-4">
                            <FormCheckboxGroupOption
                                v-for="option in planningDays"
                                :key="option.id"
                                :modelValue="modelValue.planning.days.includes(option.id)"
                                @update:modelValue="
                                    $event
                                        ? modelValue.planning.days.push(option.id)
                                        : modelValue.planning.days.splice(modelValue.planning.days.indexOf(option.id), 1)
                                ">
                                <template #title>
                                    <div class="flex justify-center">{{ __(option.name) }}</div>
                                </template>
                            </FormCheckboxGroupOption>
                        </div>
                    </FormCheckboxGroup>

                    <div>
                        <FormLabel>{{ __("Heures de publication (UTC)") }}</FormLabel>
                        <div class="max-w-xs grid grid-cols-2 gap-4 mt-4">
                            <Timepicker v-model="modelValue.planning.start_time" />
                            <Timepicker v-model="modelValue.planning.end_time" />
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </Step>
</template>
